import { isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Inject, OnInit,
  PLATFORM_ID,
} from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';
import { LinkService } from './_service/link.service';
import { LoadingService } from './_service/loading.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {

  title = 'Mercedes-Benz Veículos Comerciais';

  loading: boolean = false;
  loadingService: LoadingService;
  loadingSubscription: any;

  constructor(
      @Inject(PLATFORM_ID) private platformId: Object,
      loadingService: LoadingService,
      private cdref: ChangeDetectorRef,
      private router: Router,
      private linkService: LinkService,
  ) {

    this.loadingService = loadingService;

    this.loadingRouterControl();
  }

  ngOnInit(): void {
    this.linkService.insertingRobots();

    if (isPlatformBrowser(this.platformId)) {
      this.initLoadingService();

      this.router.events.subscribe((evt) => {
        window.scrollTo(0, 0);
      });

      // removing service work forçado
      if (window.navigator && navigator.serviceWorker) {
        navigator.serviceWorker.getRegistrations()
                 .then(function (registrations) {
                   for (let registration of registrations) {
                     registration.unregister();
                   }
                 });
      }

    }
  }

  private initLoadingService(): void {
    this.loadingSubscription = this.loadingService.getEmittedValue()
                                   .subscribe(item => {
                                     this.loading = item;
                                     this.cdref.detectChanges();
                                   });
  }

  loadingRouterControl(): void {
    this.router.events.subscribe((event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.loading = true;
          break;
        }
        case event instanceof NavigationCancel:
        case event instanceof NavigationEnd:
        case event instanceof NavigationError: {
          this.loading = false;
          if (!isPlatformBrowser(this.platformId)){
            return;
          }
          window.scrollTo(0, 0);
          break;
        }
        default: {
          break;
        }
      }
    });
  }
}
